export const monthlyPlanText = (text: string | number, isOneTime: boolean) => {
    if (!Number.isNaN(text) && text < 0) {
        const newText = (text as number) * -1;
        if (isOneTime) return `-$${Number(newText).toFixed(2)}`;
        return `-$${newText}/mo`;
    }
    if (isOneTime) return `$${Number(text).toFixed(2)}`;
    return `$${text}/mo`;
};

export default monthlyPlanText;
